import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { Modal, Offcanvas } from "react-bootstrap";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import axiosInstance from "../../../../services/api/API";
import moment from "moment";
import viewIcon from '../../../../../Assets/icons/eye 1.svg';
import "bootstrap/dist/css/bootstrap.min.css";
import AddIssueDynemicForm from "../../addIssueDynemicFrom";
import ReactSignatureCanvas from "react-signature-canvas";

const PaymentInvoiceDetails = () => {
  const location = useLocation();
  const { data } = location?.state || {};
  const navigate = useNavigate();
  const [jobCardDetails, setJobCardDetails] = useState([]);
  const [personalDetails, setPersonalDetails] = useState(null);
  const [modalType, setModalType] = useState(null);
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({ issue_status: 0});
  const [complainList, setComplainList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [signatureModel, setSignatureModel] = useState(false);
  const [UpdateModel, setUpdateModel] = useState(false);
  const [editIssueData, setEditIssueData] = useState();
  const [paybleTotalAmount, setPaybleTotalAmount] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]); 
  const [totalTransaction_Amount,setTotalTransaction_Amount] =useState(null);// Add state for remark
  const [ inVoiceIdValue , setInVoiceIdValue ] = useState("")

  const [issueId, setIssueId] = useState(0);
  const [addModel, setAddModel] = useState(false);
  const bussness_id = data?.business_partner_id;
  const job_Card_id = data?.job_card_id;

  const sigCanvas = useRef();
  const IssueInputs = [
    {
      name: "Payment_mode",
      label: "Payment Mode",
      type: "dropdown",
      placeholder: "Enter Complain Description",
      required: true,
      options: [
        {
          label: "Online",
          value: 3,
        },
        {
          label: "Cash",
          value: 1,
        },
      ],
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
        // pattern: /^[A-Za-z0-9 ]*$/,
        // message: "Only alphabets and digits are allowed",
      },
      disabled: false,
      // isVisible: false
    },
    {
      name: "transaction_Amount",
      label: "Transaction Amount",
      type: "text",
      placeholder: "Enter Transaction Amount",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
        // pattern: /^[A-Za-z0-9 ]*$/,
        // message: "Only alphabets and digits are allowed",
      },
    },
    {
      name: "Transaction_No",
      label: "Transaction No.",
      type: "text",
      placeholder: "Enter Complain Description",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
      },
    },

    {
      name: "transaction_date",
      label: "Transaction Date",
      type: "date",
      placeholder: "Enter Estimate Cost",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
    },
    {
      name: "receipt_data",
      label: "Receipt",
      type: "agentfile",
      placeholder: "Enter Estimate Cost",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
      isVisible: true,
    },
  ];

  const onClickSetIssueId = (id) => {
    if (id == "") {
      setIssueId("");
    } else {
      setIssueId(id);
    }
  };
  // useEffect(()=>{
    
  //   setFormData({...formData,transaction_date:moment(Date.now()).format("DD/MM/YYYY")})
  // },[])

  console.log("transaction_date",formData);
  
  const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcardinvoicepayment/getJobCardInvoicePaymentDetail",
        {
          business_partner_id: data?.business_partner_id || 1,
          job_card_id: data?.job_card_id || null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.data || [];
      setTotalTransaction_Amount(response?.data?.data);
      setTransactionDetails(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
    if (job_Card_id !== null) {
      try {
        const response = await axiosInstance.post(
          "/jobcardinvoicepayment/getJobCardPersonalDetails",
          {
            business_partner_id: data?.business_partner_id || 1,
            job_card_id: job_Card_id || null,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("assasas1212121", response);
        const formattedData = response?.data?.data || {};
        const fetchedData = {
          Transaction_No: formattedData.invoice_no,
         transaction_date:moment(Date.now()).format("YYYY/MM/DD"),
         Payment_mode:1,
         transaction_Amount:totalTransaction_Amount?.totalPendingAmount 
        }
        setFormData(fetchedData)
        const invoiceId = response?.data?.data?.invoice_no
        setInVoiceIdValue(invoiceId)
        setPersonalDetails(formattedData);
        // setJobCardIssueList(formattedData);
      } catch (error) {
        console.error("Error fetching business partners:", error);
      }
    }
  };
 

  const fetchComplainList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcardinvoicepayment/getInvoiceItemComplainView",
        {
          business_partner_id: data?.business_partner_id || 1,
          job_card_id: job_Card_id || null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.data || [];
      setPaybleTotalAmount(response?.data?.data);
      setComplainList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  // const handleFormSubmit = async (data) => {
  //   const formData = new FormData();
  //   formData.append("onboard_bp_id", bussness_id);
  //   formData.append("job_card_id", job_Card_id);
  //   formData.append("transaction_number", data?.Transaction_No);
  //   formData?.append("transaction_amount", data?.transaction_Amount);
  //   formData?.append(
  //     "transaction_date",
  //     moment(data?.transaction_date).format("YYYY-MM-DD")
  //   );
  //   formData?.append("receiptFile", data?.receipt_data);
  //   formData?.append("Payment_mode_id", data?.Payment_mode);
  //   try {
  //     const response = await axiosInstance.post(
  //       "/jobcardinvoicepayment/createOnlinePayment",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response?.status) {
  //       setAddModel(false);
  //       fetchJobCardIssueList();
  //       fetchJobCardDetails();
  //       setFormData({ issue_status: 0 });
  //       // const AddIssueData = response?.data?.data?.responseData;
  //       // navigate("/manage-services/job-card/job-card-details", {
  //       //   state: { data: JSON.parse(JSON.stringify(AddIssueData)) },
  //       // });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching business partners:", error);
  //   }
  // };


  const handleFormSubmit = async (data) => {
    console.log("transactionamount",data);
    
    const formData = new FormData();
    formData.append("onboard_bp_id", bussness_id);
    formData.append("job_card_id", job_Card_id);
    formData.append("transaction_number", data?.Transaction_No);
    formData?.append("transaction_amount", data?.transaction_Amount);
    formData?.append(
      "transaction_date",
      moment(data?.transaction_date).format("YYYY-MM-DD")
    );
    if (data?.Payment_mode === 3 && data?.receipt_data) {
      formData?.append("receiptFile", data?.receipt_data);
    }
    formData?.append("Payment_mode_id", data?.Payment_mode);
  
    try {
      let response;
      // Conditionally call API based on Payment Mode
      if (data?.Payment_mode === 3) {  // Online payment
        response = await axiosInstance.post(
          "/jobcardinvoicepayment/createOnlinePayment",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else if (data?.Payment_mode === 1) {  // Cash payment
        response = await axiosInstance.post(
          "/jobcardinvoicepayment/createOfflinePayment",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
          }
        );
      }
  
      if (response?.status) {
        setAddModel(false);
        setUpdateModel(false)
        fetchJobCardIssueList();
        fetchJobCardDetails();
        setFormData({ issue_status: 0 });
      }
    } catch (error) {
      console.error("Error during payment submission:", error);
    }
  };

  const editOpenData = (issueDetails) => {
    setEditIssueData(issueDetails);
    if (issueDetails?.comp_id) {
      setFormData({
        Complain: issueDetails?.complain_id,
        Complain_Description: issueDetails?.complain_desc,
        estimated_cost: issueDetails?.estcost,
        remark: issueDetails?.remark,
        issue_status: issueDetails?.issue_status,
        east_time: issueDetails?.esttime,
        repair: issueDetails?.repair_id,
        technician: issueDetails?.technician_id,
      });
    }
    setAddModel(true);
  };

  const handleClose = () => {
    setUpdateModel(false);
  };

  useEffect(() => {
    if (data) {
      fetchJobCardIssueList();
      fetchJobCardDetails();
      fetchComplainList();
    }
  }, [data,UpdateModel]);

  const openImageInNewTab = (transactionDetails) => {
    window.open(`http://127.0.0.1:8599/public/upload/${transactionDetails?.receipt_path}`,);
  };

    const backNavigate = () => {
    navigate("/manage-services/job-card-invoice-payment");
  };

  
  return (
    <div className="container-fuiled">
      <div className="OnboardManagamentContainer  mt-2 mb-2">
        <span className="backbtntitle">
          {" "}
          <img src={backicon} alt="back" style={{ marginRight: 5 }} onClick={()=>backNavigate()}/> Payment
          Invoice Details
        </span>
        <div className="gap-5">
        {/* {totalTransaction_Amount?.totalPaidAmount !== 0 && ( */}
        {personalDetails?.payment_status ===0&&(
        <button 
        className="addcustomerbutton "
            onClick={() => setUpdateModel(true)}
        >
          Update
        </button>
          )}
        </div>
    
      </div>
      <div className="container-fuiled row   ">
        <div className="col-md-6 vechalDetails">
          <div>
            <h5 className="m-3">Personal Details</h5>
            <div className="mt-3 m-3">
              <div className="invoice-vechal-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Invoice No.</span>
                  <span className="details-value">
                    {personalDetails?.invoice_no || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Job Card No.</span>
                  <span className="details-value">
                    {personalDetails?.job_card_no || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Job Card Type</span>
                  <span className="details-value">
                    {personalDetails?.job_type || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Customer Name</span>
                  <span className="details-value">
                    {personalDetails?.customer_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Mobile No.</span>
                  <span className="details-value">
                    {personalDetails?.contact_no || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Email Id</span>
                  <span className="details-value">
                    {personalDetails?.email_id || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">PIN Code</span>
                  <span className="details-value">
                    {personalDetails?.pincode || "-"}
                  </span>
                </div>

                {/* <div className="details-item">
                  <span className="details-label">Address</span>
                  <span className="details-value">
                    {personalDetails?.address || "-"}
                  </span>
                </div> */}
                <div className="details-item">
                  <span className="details-label">Address</span>
                  <span className="details-value">
                    {personalDetails?.address
                      ? personalDetails.address.length > 40
                        ? `${personalDetails.address.substring(0, 50)}...`
                        : personalDetails.address
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
            <br />
            <div className="borderWidth">
              <h5 className="m-3">Vehicle Details</h5>
            </div>
            <div className="mt-3 m-3">
              <div className="invoice-vechal-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Product</span>
                  <span className="details-value">
                    {personalDetails?.product_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Sub Product</span>
                  <span className="details-value">
                    {personalDetails?.subproduct_name || ""}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Make</span>
                  <span className="details-value">
                    {personalDetails?.make_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Model</span>
                  <span className="details-value">
                    {personalDetails?.model_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Variant</span>
                  <span className="details-value">
                    {personalDetails?.variant_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Color</span>
                  <span className="details-value">
                    {personalDetails?.color_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Fuel Type</span>
                  <span className="details-value">
                    {personalDetails?.fuel_type_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Chassis No.</span>
                  <span className="details-value">
                    {personalDetails?.chassis_no || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Engine No.</span>
                  <span className="details-value">
                    {personalDetails?.engineno || "-"}
                  </span>
                </div>

                <div className="details-item">
                  <span className="details-label">Registration No.</span>
                  <span className="details-value">
                    {personalDetails?.registration_no || "-"}
                  </span>
                </div>
              </div>
            </div>
            <br />
            <div className="borderWidth">
              <h5 className="m-3">Services Details</h5>
            </div>
            <div className="mt-3 m-3">
              {/* <div className="invoice-vechal-Details-SubView"> */}
              <table className="payment-invoice-table">
                <thead>
                  <tr>
                    <th>Part Name</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Total Cost</th>
                  </tr>
                </thead>
                <tbody>
                  {(complainList || []).map((complainDetails, index) => (
                    <tr key={index + 1}>
                      <td className="text">
                        {complainDetails?.item_name || "-"}
                      </td>
                      <td className="text">
                        {complainDetails?.good_qty || "-"}
                      </td>
                      <td className="price">
                        &#8377; {complainDetails?.rate || "-"}
                      </td>
                      <td className="price">
                        &#8377; {complainDetails?.item_total_amount || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={3}>Total</td>
                    <td> &#8377;{paybleTotalAmount?.SubTotal || "-"}</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>Tax ({paybleTotalAmount?.Gst || "-"})</td>
                    <td> &#8377;{paybleTotalAmount?.GstAmount || "-"}</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>Total Payable Amount</td>
                    <td> &#8377;{paybleTotalAmount?.Total || "-"}</td>
                  </tr>
                </tfoot>
              </table>
              {/* <footer className="invoice-footer">
          <div className="pminfo"></div>
          <div className="total">
            <div className="totalval">
              
              <span>Subtotal:</span>
              <span>&#8377;{'5000' ||'-'}</span>
            </div>
            <div className="totalval">
              <span>Tax ({'18'}):</span> <span>&#8377;{Number('4000').toFixed(2) || '0'}</span>
            </div>
            <div className="grandtotal">
              <span>Grand Total: </span>
              <span>&#8377;{ Number('5000').toFixed(2) || '0'}</span>
            </div>
          </div>
        </footer> */}
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="addButtonStyle m-3">
            <h5>Payment History</h5>
          </div>
          <div className="issue-list-parent-container">
            <table className="payment-invoice-table">
              <thead>
                <tr>
                  <th>Payment Mode</th>
                  <th>Tran. No.</th>
                  <th>Tran. Date</th>
                  <th>Upload Image</th>
                  <th>Tran. Amount</th>
                </tr>
              </thead>
              <tbody>
              {(transactionDetails || []).map((transactionDetails, index) => (
                <tr key={index}>
                  <td className="text">
                    {transactionDetails?.payment_mode || "-"}
                  </td>
                  <td className="text">
                    {transactionDetails?.transaction_number || "-"}
                  </td>
                  <td className="text">
                    {moment(transactionDetails?.transaction_date).format("DD/MM/YYYY") || "-"}
                  </td>
                  <td className="text">
                    {transactionDetails?.payment_mode === "Online" ? (
                      <div>
                        <img
                          src={`http://127.0.0.1:8599/public/upload/${transactionDetails?.receipt_path}`}
                          style={{ width: 20, height: 20, alignItems: 'center', cursor:"pointer" }}
                          onClick={() => openImageInNewTab(transactionDetails)}
                          alt="Receipt"
                        />
                      </div>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td className="price">
                    &#8377; {transactionDetails?.transaction_amount || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
              <tfoot>
                <tr>
                  <td className="textleft"> Total Amt.</td>
                  <td className="textleft">&#8377;{totalTransaction_Amount?.totalAmount || '-'}</td>
                  <td className="textleft">Pending Amt.</td>
                    <td className="textleft"> &#8377;{totalTransaction_Amount?.totalPendingAmount  || "-"}</td>
                    <td> &#8377;{totalTransaction_Amount?.totalPaidAmount || "-"}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <Offcanvas placement={"end"} show={UpdateModel} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {"Add Payment Details"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="col-lg-12">
            {/* <AddIssueDynemicForm
              formConfig={IssueInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            /> */}

              <AddIssueDynemicForm
                formConfig={IssueInputs.map(input => {
                  if (input.name === "receipt_data") {
                    // Conditionally set visibility of receipt_data based on Payment_mode
                    return {
                      ...input,
                      isVisible: formData?.Payment_mode !== 1, // Hide if Payment_mode is Cash (value = 1)
                    };
                  }
                  return input;
                })}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />

            <div className="col-12 ">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn w-100"
              >
                {"Submit"}
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default PaymentInvoiceDetails;
